<template>
  <div class="loading-splash">
    <LoadingIcon :style="{ maxWidth: width }" />
    <span>{{ text ?? "Loading….." }}</span>
  </div>
</template>

<script setup lang="ts">
import LoadingIcon from "@/assets/icons/loading.svg";
defineProps<{
  colSpan?: number;
  text?: string;
  width?: string;
}>();
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.small {
  svg {
    max-width: 70px !important;
  }
}

.loading-splash {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  justify-content: center;
  align-items: center;
  svg {
    width: 100px;
    height: 100px;
    color: $primary-300;
    path {
      fill: $primary-300;
    }
    animation: spin 1s linear infinite;
  }
}
</style>
